<template>
	<!--团队-->
	<div class="box">
		<div class="joinedComposition" v-if="tdxqBool==false">
			<div class="header">
				<div class="fl">
					<span>专家团队管理</span>
				</div>
				<div v-show="mzglBool">
					<div>
						
					</div>
				</div>
			</div>
			<div class="content_user">
				<div class="fl">
					<div class="navMenuTd active" @click="tabClick('1',$event)">
						<span>团队管理</span>
						<i class=""></i>
					</div>
				</div>
				<div>
					<div v-if="mokuai==1">
						<div class="tdBox">
							<div class="tdBox_div" v-for="item in tdBox">
								<p>{{item.name}}团队</p>
								<div>
									<button @click="tdFn(item.id)">团队详情</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<div class="myJoined" v-if="tdxqBool==true">
			<div class="headers">
				<div class="fl">
					<i class="" style="cursor: pointer;" @click="tdxqBool=false"></i>
					<span></span>
					<span>团队详情</span>
				</div>
				<div v-show="mzglBool">
					<div>
						
					</div>
				</div>
			</div>
			<div class="doctorzjtd">
				<div class="doctorzjtd_list">
					<p>成员权限管理</p>
					<div class="doctorzjtd_list_qx">
						<div v-for="(item,index) in doctorlist">
							<div><img :src="item.headerImg"/></div>
							<div><span>{{item.name}}</span></div>
							<div v-if="item.xzBool==false"><button v-if="index!=0"  @click="jzFn(index)">协助接诊</button></div>
							<div v-if="item.xzBool==true"><button style="background: #CCCCCC;"  @click="jzqxFn(index)">协助接诊</button></div>
						</div>
					</div>
				</div>
				<div class="doctorzjtd_userxq">
					<div class="user_list" v-for="item in doctortd">
						<div>
							<img :src="item.headerImg"/>
							<p>{{item.type==1?'专家':'副专家'}}</p>
							<p>{{item.name}}</p>
						</div>
						<div>
							<div class="useradd_list" v-for="items in item.childen">
								<img :src="items.headerImg"/>
								<p>{{items.name}}</p>
								<p @click="delecyFn">删除成员</p>
							</div>
							<div class="useradd_list useradd_listhover" style="cursor: pointer;"  @click="addCyBool=true">
								<img src="../../../assets/image/addcy.jpg"/>
								<p>添加成员</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialogAddopple" v-if="addCyBool">
			<div>
				<div class="addHeader">
					<p><i class="el-icon-close fr" style="cursor: pointer;" @click="addCyBool=false"></i></p>
					<p>添加成员</p>
				</div>
				<div class="addCenter">
					<p>请您输入添加成员的手机号</p>
					<div>
						<div>
							<input type="text" name="" id="" value="" v-model="tel" />
						</div>
						<div>
							<button @click="ssFn">搜索</button>
						</div>
					</div>
					
				</div>
				<div class="addlist">
					<div class="doctor_list" v-for="item in userArr" @click="arrpushFn(item.uTel)">
						<div>
							<img :src="item.uImgA" ></img>
							<div v-if="arrifFn(item.uTel)">已选择</div>
						</div>
						<div>{{item.uName}}</div>
						<div>{{item.tName}}</div>
					</div>
				</div>
				<div class="addFooter">
					<div v-if="telArr.length!=0">
						<button @click="get_company">确定添加</button>
					</div>
					<div v-if="telArr.length==0">
						<button  style="background: #CCCCCC;">确定添加</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState,mapMutations} from 'vuex'
	import {user_row,get_company } from '../../http/api.js'
	import {doctor} from '../../../assets/js/doctor.js'
	export default{
		components:{
		},
		data(){
			return{
				companysrow:{},
				csVal:'',
				glList:[],
				drList:[],
				atList:[],
				addCyBool:false,
				tdlist:[],
				tel:'',
				xxgsVal:false,
				sqVal:true,
				nameVal:'',
				zspwdVal:'',
				addressVal:'',
				lxtel:'',
				gfwzVal:'',
				vxVal:'',
				ylImg:'',
				yyImg:'',
				sList:[],
				sheng:'',
				shiList:[],
				shi:'',
				xianList:[],
				xian:'',
				glyName:'',
				usersetBool:false,
				mrImg:'http://api.bats-bio.com/upload/2019-10-23/5dafbb3a5a2f6.png',
				yyxkImg:false,
				yyzzImg:false,
				mzglBool:false,
				cyglBool:false,
				szczBool:false,
				minname:'',
				xiugaiqueding:false,
		    	deleUser:[],
		    	lxdhval:'',
		    	centerDialogVisible:false,
				DialogImg:'',
				thiscpyId:this.cpyId,
				setglyBool:false,
				uNameGly:'',
				uIdGly:'',
				sqList:[],
				xxgsRz:'',
				lxdhvalqh:'',
				lxdhvalhm:'',
				cIsRZ:'',
				dialoggrzyBool:false,
				wsdaqBool:false,
				tiuchuzhensuoBool:false,
				mokuai:1,
				tdxqBool:false,
				tdBox:[{
					name:'贾培增',
					id:0,
				},{
					name:'王雪东',
					id:1
				},{
					name:'张晶晶',
					id:2
				}],
				doctorlist:[],
				doctortd:[],
				addCyBool:false,
				tel:'',
				userArr:[],
				telArr:[]
			}
		},
		created(){
//			this.chengshiFn();
		},
		mounted(){
//			this.companys_rowFn();
		},
		methods:{
			arrifFn(tel){
				for(var i=0;i<this.telArr.length;i++){
					if(this.telArr[i]==tel){
						return true
					}
				}
				
			},
			arrifFn1(tel){
				for(var i=0;i<this.userArr.length;i++){
					if(this.userArr[i].uTel==tel){
						return true
					}
				}
				
			},
			arrpushFn(tel){
				if(this.arrifFn(tel)){
					for(var i=0;i<this.telArr.length;i++){
						if(this.telArr[i]==tel){
							this.telArr.splice(i,1)
						}
					}
				}else{
					this.telArr.push(tel);
					
				}
			},
			ssFn(){
				var data = {
					uTel:this.tel
				}
				var that=this;
				user_row(data).then(res=>{
					console.log(res)
					that.tel='';
					if(that.arrifFn1(res.row.uTel)){
						that.$message({
							message: '请勿重复查询',
							type: 'info',
							duration: 1000,
							onClose: () => {
							}
						})
					}else{
						if(res.row.uTel==null){
							that.$message({
								message: '该用户不存在',
								type: 'error',
								duration: 1000,
								onClose: () => {
								}
							})
						}else{
							that.userArr.push(res.row)
						}
						
					}
				})
			},
			get_company(tel){
				 this.addCyBool=false;
				 this.$message({
					message: '添加完成',
					type: 'success',
					duration: 1000,
					onClose: () => {
					}
				})
			},
			jzFn(i){
				this.doctorlist[i].xzBool=!this.doctorlist[i].xzBool;
				this.$message({
						message: '设置成功',
						type: 'success',
						duration: 1000,
						onClose: () => {
						}
					})
				console.log(this.doctorlist[i])
			},
			jzqxFn(i){
				this.doctorlist[i].xzBool=!this.doctorlist[i].xzBool;
				this.$message({
						message: '设置成功',
						type: 'info',
						duration: 1000,
						onClose: () => {
						}
					})
			},
			delecyFn(){
				this.$confirm('确定删除此团队成员吗?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		          
		        }).catch(() => {
		                  
		        });
			},
			 move(e){
	            let odiv = e.target;  
	            let disX = e.clientX - odiv.offsetLeft;
	            let disY = e.clientY - odiv.offsetTop;
	            document.onmousemove = (e)=>{    
	                let left = e.clientX - disX;    
	                let top = e.clientY - disY;
                	odiv.style.left = left + 'px';
                	odiv.style.top = top + 'px';
	            };
	            document.onmouseup = (e) => {
	                document.onmousemove = null;
	                document.onmouseup = null;
	            };
		    },
			tdFn(val){
				if(val==0){
					this.doctorlist=doctor.jpzlist;
					this.doctortd=doctor.jpztd;
					this.tdxqBool=true;
				}else if(val==1){
					this.doctorlist=doctor.wxdlist;
					this.doctortd=doctor.wxdtd;
					this.tdxqBool=true;
				}else{
					
				}
			},
			
			
			fhFn(bol){
				this.$emit('getMessage', bol)
			},
			imgCloseFn(){
				this.yyzzImg=false;
				this.yyxkImg=false;
			},
			
			up(a,b){
				return a.uTypeID-b.uTypeID
			},
			deleteFn(id){
				var data={
					cpy_id:this.companysrow.id,
					uid:id
				}
				users_delete_from_company(data).then(res=>{
//					console.log(res.data)
				})
			},
			setglyFn(){
				var data={
					uid:this.uIdGly,
					cpy_id:this.companysrow.id,
					zt:1
				}
				set_dual_status(data).then(res=>{
					this.$message({
			            type: 'success',
			            message: '设置成功',
						duration: 1000,
			            onClose: () => {
							this.setglyBool=false;
							this.glListFn();
						}
			        });
				})
			},
			remoreArr(id,event,typeid){
				for(var i=0;i<this.deleUser.length;i++){
					if(this.deleUser[i]==id){
						this.deleUser.splice(1,1);
						var el = event.currentTarget; 
						$(el).hide();
						$(el).siblings('.el-icon-delete-solid').show();
					}
				}
			},
		    tabClick(str,el){
				var el = event.currentTarget; 
				$(el).addClass('active').siblings().removeClass('active')
				this.mokuai=str;
			},
		},
		computed: {
			...mapState(['is_two','login_id'])
		},
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height:836px;
	}
	.notJoined{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.notJoined>div{
		width:299px;
		height:274px;
		padding:0 40px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 12px 0px rgba(0,0,0,0.13);
		border-radius:8px;
		margin-top: -100px;
	}
	.notJoined>div>div:nth-child(2){
		font-size:14px;
		font-family:PingFangSC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
		margin-bottom: 60px;
		margin-top: 90px;
	}
	.notJoined>div:nth-child(1)>div:nth-child(3)>button{
		width:299px;
		height:35px;
		background:rgba(176,176,176,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:16px;
	}
	.notJoined>div:nth-child(2)>div:nth-child(3)>button{
		width:299px;
		height:35px;
		background:rgba(0,120,255,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:16px;
	}
	.myJoined,.joinedComposition{
		width: 100%;
		height:836px;
		background:rgba(255,255,255,1);
		box-shadow:2px 2px 2px 0px rgba(119,151,178,0.16);
	}
	.header,.headers{
		width:100%;
		height:72px;
		background:rgba(255,255,255,1);
		box-shadow:0px 2px 2px 0px rgba(119,151,178,0.16);
		z-index: 90;
		position: relative;
		overflow: hidden;
	}
	.header>div:nth-child(1),.headers>div:nth-child(1){
		width:255px;
		height: 100%;
		float: left;	
		position: absolute;
		display: flex;
		align-items: center;
	}
	.headers>div:nth-child(1)>i{
		margin-left: 23px;
		margin-right: 12px;
		display: block;
		width:7px;
		height:13px;
		background:url(../../../assets/image/left.png) no-repeat center center;
		background-size:100% ;
	}
	.headers>div:nth-child(1)>i:hover{
		margin-left: 21px;
		margin-right: 12px;
		display: block;
		cursor: pointer;
		width:9px;
		height:15px;
		background:url(../../../assets/image/left.png) no-repeat center center;
		background-size:100% ;
	}
	.headers>div:nth-child(1)>span:nth-child(2){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(155,155,155,1);
		line-height:68px;
	}
	.headers>div:nth-child(1)>span:nth-child(3){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(74, 74, 74, 1);
		line-height:68px;
		margin-left: 14px;
		
	}
	.header>div:nth-child(1)>span:nth-child(1){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(74, 74, 74, 1);
		line-height:68px;
		margin-left: 14px;
		
	}
	.header>div:nth-child(2){
		margin-left: 130px;
		height: 100%;
	}
	.header>div:nth-child(2)>div:nth-child(1){
		width: 100%;
	}
	.content_user,.doctorzjtd{
		width:100%;
		height:760px;
		background:RGBA(235, 235, 235, 1);
		overflow: hidden;
	}
	.joinedList>div{
		width:216px;
		height:118px;
		background:rgba(255,255,255,.7);
		border-radius:3px;
		font-size:14px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(74,74,74,1);
		text-align: center;
		line-height: 118px;
		margin: 10px 0;
	}
	.content_user>div.fl{
		width:206px;
		height:760px;
		background:#F6F6F6;
		box-shadow:2px 0px 4px 0px rgba(155,155,155,0.23);
		position: absolute;
		z-index: 999;
	}
	.content_user>div:nth-child(2){
		margin-left: 206px;		
	}
	.content_user>div:nth-child(2)>div{
		padding: 10px;
	}
	.navMenuTd:nth-child(1){
		z-index: 999;
		padding-top:0px;
		margin-top: 0px;
	}
	.navMenuTd:nth-child(2){
		z-index: 998;
	}.navMenuTd:nth-child(3){
		z-index: 997;
		
	}
	.navMenuTd{
		width:206px;
		height:50px;
		padding-top:10px;
		margin-top: -10px;
		background:rgba(246,246,246,1);
		box-shadow:0px 2px 4px 0px rgba(155,155,155,0.4);
		border-radius:0px 0px 15px 0px;
		cursor: pointer;
		line-height:50px;
		position: relative;
		margin-bottom: 5px;
	}
	.navMenuTd>span{
		font-size:14px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		margin-left: 15px;
	}
	.navMenuTd:nth-child(1)>i{
		top: 19px;
	}
	.navMenuTd>i{
		display: block;
		width:7px;
		height:13px;
		background: url(../../../assets/image/navMenuTd.png) no-repeat center center;
		background-size:100% ;
		position: absolute;
		right: 40px;
		top: 29px;
		/*transition: .3s all;*/
	}
	.navMenuTd:hover{
		background: #FFFFFF;
	}
	.navMenuTd:hover span{
		color:#3B97FF ;		
		
	}
	.navMenuTd:hover i{
		background: url(../../../assets/image/navMenuTdActive.png) no-repeat center center;
		background-size:100% ;
	}
	.navMenuTd.active{
		background: #FFFFFF;
		
	}
	.navMenuTd.active>span{
			color:#3B97FF ;		
	}
	.navMenuTd.active>i{
		background: url(../../../assets/image/navMenuTdActive.png) no-repeat center center;
		background-size:100% ;
	    transform: rotate(90deg);
	    transition: .3s all;
	}
	i.active{
		display: block;
		width:14px;
		height:14px;
		float: left;
		border-radius: 50%;
		margin-right: 3px;
		background: rgba(0, 120, 255, 1);
	}
	.tdBox_div{
		width: 220px;
		height: 160px;
		background: #FFFFFF;
		overflow: hidden;
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 5px;
	}
	.tdBox_div>p{
		margin-top: 45px;
		font-size:20px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		text-align: center;
		margin-bottom:10px;
	}
	.tdBox{
		display: flex;
		flex-wrap: wrap;
	}
	.tdBox_div>div {
		width: 100px;
		height: 30px;
		margin: 0 auto;
		margin-top: 20px;

	}
	.tdBox_div>div:hover button {
		border: 2px solid yellow;
	}
	
	.tdBox_div>div>button {
		float: left;
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	.doctorzjtd_list{
		width: 330px;
		padding: 0 10px;
		height: 100%;
		background: #FFFFFF;
		overflow: hidden;
		float: left;
	}
	.doctorzjtd_list>p{
		font-size:16px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		margin: 10px 0;
	}
	.doctorzjtd_list_qx{
		height: calc(100% - 30px);
		overflow-x: scroll;
	}
	.doctorzjtd_list_qx>div{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
		overflow: hidden;
	}
	.doctorzjtd_list_qx>div>div:nth-child(1)>img{
		border-radius: 50%;
		width: 80px;
		height: 80px;
	}
	.doctorzjtd_list_qx>div>div:nth-child(2){
		font-size:16px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		margin-left: 15px;
		margin-right: 30px;
		
	}
	.doctorzjtd_list_qx>div>div:nth-child(3){
		
	}
	.doctorzjtd_list_qx>div>div:nth-child(3){
		width: 100px;
		height: 30px;
		margin-right: 20px;

	}
	.doctorzjtd_list_qx>div>div:nth-child(3):hover button {
		border: 2px solid yellow;
	}
	
	.doctorzjtd_list_qx>div>div:nth-child(3)>button {
		float: left;
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	.doctorzjtd_userxq{
		margin-left: 350px;
		height:100% ;
		overflow-x: scroll;
	}
	.doctorzjtd_userxq>div{
		/*height: 100px;*/
	}
	.doctorzjtd_userxq>div>div{
		
	}
	.user_list{
		margin: 40px 20px;
		min-height: 150px;
		/*overflow: hidden;*/
		display: flex;
		align-items: center;
		position: relative;
	}
	.user_list:nth-child(1){
		margin-top: 20px;
	}
	.user_list:nth-child(1)::before{
		display: none;
	}
	.user_list:last-child::after{
		display: none;
	}
	.user_list::before{
		display: block;
		content: "";
		width: 1px;
		height:calc((100%/3) + 40px);
		background: #000000;
		position: absolute;
		/*top: calc(100%/-2);*/
		top: -40px;
		left: 40px;
	}
	.user_list::after{
		display: block;
		content: "";
		width: 1px;
		height: calc(100%/3);
		background: #000000;
		position: absolute;
		top: calc(100%/1.5);
		left: 40px;
	}
	
	.user_list>div:nth-child(1){
		width: 80px;
		height: 125px;
		background: RGBA(235, 235, 235, 1);
		border-top:30px solid RGBA(235, 235, 235, 1) ;
		border-bottom:30px solid RGBA(235, 235, 235, 1) ;
		position: relative;
		z-index: 999;
	}
	.user_list>div:nth-child(1)>img{
		width: 80px;
		height: 80px;
		border-radius: 50%;
		margin-bottom:8px;
		position: relative;
		z-index: 999;
	}
	.user_list>div:nth-child(1)>p:nth-child(2){
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color:#0000FF;
		text-align: center;
		margin-bottom:8px;
	}
	.user_list>div:nth-child(1)>p:nth-child(3){
		font-size: 15px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color:#000000;
		text-align: center;
		position: relative;
		z-index: 999;
		
	}
	.user_list>div:nth-child(2){
		width: 1000px;
		padding: 20px 20px 0px 20px;
		margin-left: 100px;
		min-height: 110px;
		box-shadow:0px 2px 2px 0px rgba(119,151,178,0.16);
		background: #FFFFFF;
	}
	.user_list>div:nth-child(2){
		display: flex;
		flex-wrap: wrap;
	}
	.user_list>div:nth-child(2)::after{
		display: block;
		content: "";
		width: 75px;
		height: 1px;
		background: #000000;
		position: absolute;
		top: 50%;
		left: 90px;
	}
	.useradd_list{
		width: 70px;
		margin-right: 20px;
		margin-bottom: 20px;
		/*height: 120px;*/
	}
	.useradd_list>img{
		width: 70px;
		height: 70px;
		margin-bottom: 8px;
		border-radius: 50%;
	}
	.useradd_list>p:nth-child(2){
		font-size: 15px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color:#000000;
		text-align: center;
		margin-bottom: 8px;
	}
	.useradd_list>p:nth-child(3){
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color:red;
		text-align: center;
		/*display: flex;*/
		cursor: pointer;
		padding-bottom: 2px;
		border-bottom: 1px solid transparent;
		text-align: center;
	}
	.useradd_list>p:nth-child(3):hover{
		border-bottom: 1px solid red;
	}
	.dialogAddopple {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .3);
		z-index:1000;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.useradd_listhover:hover img{
		opacity: .8;
	}
	.useradd_listhover:hover p{
		color: #1db5ff;
	}
	.dialogAddopple>div {
		width: 312px;
		min-height: 268px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 4px 0px 12px 0px rgba(0, 0, 0, 0.13);
		border-radius: 10px;
		padding: 30px 30px;
	}
	
	.dialogAddopple>div>div:nth-child(1)>p:nth-child(2) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 25px;
	}
	
	.dialogAddopple>div>div:nth-child(1)>p:nth-child(1) {
		font-size: 20px;
		margin-bottom: 15px;
		font-weight: bold;
		overflow: hidden;
	}
	
	.addHeader {
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(241, 241, 241, 1);
	}
	
	.addCenter>p {
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		margin-top: 20px;
		margin-bottom: 5px;
	}
	.addCenter>div{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.addCenter>div>div>input {
		width:202px;
		height: 20px;
		padding: 10px;
		background: rgba(255, 255, 255, 1);
		border-radius: 8px;
		outline: none;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		border: 1px solid rgba(221, 227, 232, 1);

	}
	.addCenter>div>div:nth-child(2){
		width: 100px;
		height: 40px;
		/*margin-right: 20px;*/

	}
	.addCenter>div>div:nth-child(2):hover button {
		border: 2px solid yellow;
	}
	
	.addCenter>div>div:nth-child(2)>button {
		/*float: left;*/
		width: 100px;
		height: 40px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	.addlist{
		margin-top: 30px;
	}
	.addFooter {
		margin-top: 30px;
	}
	
	.addFooter>div {
		width: 311px;
		height: 40px;
	}
	
	.addFooter>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.addFooter>div>button {
		width: 311px;
		height: 40px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	.doctor_list{
		display: inline-block;
		text-align: center;
		margin-right: 10px;
		width:60px;
		cursor: pointer;
	}
	.doctor_list>div:nth-child(1){
		border-radius: 50%;
		overflow: hidden;
		width: 60px;
		height: 60px;
		background: #CCCCCC;
		position: relative;
		margin: 0 auto;
	}
	.doctor_list>div:nth-child(1)>div{
		border-radius: 50%;
		overflow: hidden;
		width: 60px;
		height: 60px;
		background: rgba(0,0,0,.5);
		position: absolute;
		top: 0;
		left: 0;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.doctor_list>div:nth-child(1)>img{
		width: 60px;
		height: 60px;
	}
	.doctor_list>div{
		font-size:16px;
		font-weight: 400;
		color: #4A4A4A;
		/*line-height: 36px;*/
		letter-spacing: 0px;
		margin-top: 6px;
	}
</style>

<style type="text/css">
	.comClass2 .el-upload{
		width:177px;
		height:130px;
	}
	.el-dialog--center .el-dialog__body{
		text-align: center;
	}
</style>
<!---->


// WEBPACK FOOTER //
// src/components/MA/accountManagement/doctorExpert.vue